import { FaRegTimesCircle } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';

import { tv } from '../../utils/customTv';
import { clsxMerge } from '../common/utils/classNameUtils';

const errorAlert = tv({
  base: 'absolute top-0 left-0 right-0 z-10',
});

interface ErrorAlertProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
  onDismiss: () => void;
}

export function ErrorAlert({
  message,
  onDismiss,
  className,
  ...props
}: ErrorAlertProps) {
  return (
    <div {...props} className={clsxMerge(errorAlert(), className)}>
      <div className="bg-red-50 min-w-[300px] border border-red-200 rounded-md p-3 shadow-lg transform animate-in slide-in-from-bottom-2 fade-in duration-500">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-2">
            <FaRegTimesCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
            <div className="text-red-800 text-sm">{message}</div>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            className="ml-2 text-red-600 hover:text-red-800 flex-shrink-0 p-0.5"
            aria-label="Dismiss error"
          >
            <IoClose className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
